<template>
  <div>
    <div class="header2">
      <van-nav-bar
        :title="titleName"
        left-text="返回"
        left-arrow
        @click-left="goBack"
      />
    </div>
    <van-form @submit="onSubmit">
      <div class="form-sty">
        <van-field
          required
          v-model="title"
          label="问卷问题"
          placeholder="问卷问题"
          :rules="[{ required: true, message: '请填写问题' }]"
        />
      </div>
      <div class="options">选项</div>
      <div class="options-1" v-for="(item,index) in optionList" :key="index">
        <van-image
          class="opt-img"
          :src="require('@/assets/img/delete.png')"
          @click="onDelete(index)"
        />
        <van-field v-model="item.optionsDesc" clearable placeholder="输入选项" />
      </div>
      <div class="add-options">
          <van-button @click.prevent="addOption" block plain hairline icon="plus" type="info">添加选项</van-button>
      </div>
      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit"
          >提交</van-button
        >
      </div>
    </van-form>
  </div>
</template>
<script>
import { Dialog } from 'vant'
import URL from '@/api/api'

export default {
  data() {
    return {
      titleName: this.$route.query.name,
      title: "",
      questionId: '',
      editData: null,
      typeId: '', //问卷id
      optionType: '',//单选还是多选
      optionList:[
          {optionsDesc:''},
          {optionsDesc:''},
      ]
    };
  },
  mounted(){
    this.typeId = this.$route.query.id
    this.optionType = this.$route.query.name
    this.editData = this.$route.query.data
    if (this.editData != null) {
      this.questionId = this.editData.id
      this.optionType = this.editData.questionType
      this.title = this.editData.questionDesc
      this.optionList = this.editData.optionsList
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    onSubmit(values) {
      let dataList=[]
      this.optionList.map(x=>{
        dataList.push(x.optionsDesc)
    })
      let data={
          questionId : this.questionId,
          question : this.title,
          optionList : dataList,
          typeId : this.typeId,
          optionType : this.optionType
      }
      this.$fetchPost(URL.saveOption.url, data).then(res => {
        if (res.data.code == 20000) {
          this.$router.push({ path : '/editQuestionnaire/details', query : { typeId : this.$route.query.id, isBack : 1 }});
        }
      })
    },
    onDelete(index){
        Dialog.confirm({
            title: '系统提示',
            message: '是否确认删除此选项？',
            })
            .then(() => {
                this.optionList.map((x,i)=>{
                    if(i==index){
                        this.optionList.splice(i,1);
                    }
                })
            })
            .catch(() => {
                return false
            });

    },
    addOption(){
        this.optionList.push({optionsDesc:''})
    }
  },
};
</script>
<style scoped>
.form-sty >>> .van-cell {
  display: block;
}
.form-sty >>> .van-field__control {
  border: 1px solid #c0c4cc;
  border-radius: 5px;
  padding: 10px 5px;
}
.options {
  color: #646566;
  font-size: 14px;
  padding: 10px;
}
.options-1 {
  position: relative;
  border-bottom: 1px solid #e4e7ed;
}
.opt-img {
  position: absolute;
  top: 50%;
  z-index: 99;
  transform: translateY(-50%);
  left: 2.5%;
  width: 20px;
}
.options-1 >>> .van-field__control {
  padding: 10px 20px;
}
.add-options{
    background: #fff;
}
.van-button--info{
    border: transparent;
    width: 110px;
}
</style>
